function isPostalCodeValid(postalCode) {
    return postalCode
        && postalCode.length === 5
        && /^\d+$/.test(postalCode)
        && -1 < parseInt(postalCode, 10)
        && parseInt(postalCode, 10) < 100000;
};

export { isPostalCodeValid };
